import axios from '../../axios'

export const getNotifications = async () => {
  try {
    const response = await axios.get('/v1/notifications')

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getNotification = async (id) => {
  try {
    const response = await axios.get(`/v1/notifications/${id}`)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}
